import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { PoiBody } from '../entities/poi-body';

@Injectable()
export class PoiBodyService extends BaseCrudService<PoiBody> {

  public uri = '/api/poiBody/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance PoiBodyService');
  }

  buildSentence(entity?: PoiBody, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.goal ?
          `goal${QueryOperator.Contain}${entity.goal}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.goalType ?
          `goalType${QueryOperator.Contain}${entity.goalType}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.month01 ?
          `month01${QueryOperator.Contain}${entity.month01}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.month02 ?
          `month02${QueryOperator.Contain}${entity.month02}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.month03 ?
          `month03${QueryOperator.Contain}${entity.month03}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.month04 ?
          `month04${QueryOperator.Contain}${entity.month04}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.month05 ?
          `month05${QueryOperator.Contain}${entity.month05}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.month06 ?
          `month06${QueryOperator.Contain}${entity.month06}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.month07 ?
          `month07${QueryOperator.Contain}${entity.month07}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.month08 ?
          `month08${QueryOperator.Contain}${entity.month08}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.month09 ?
          `month09${QueryOperator.Contain}${entity.month09}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.month10 ?
          `month10${QueryOperator.Contain}${entity.month10}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.month11 ?
          `month11${QueryOperator.Contain}${entity.month11}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.month12 ?
          `month12${QueryOperator.Contain}${entity.month12}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.operatingActivity ?
          `operatingActivity${QueryOperator.Contain}${entity.operatingActivity}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.code ?
          `code${QueryOperator.Contain}${entity.code}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.expenseNature && entity.expenseNature.id) {
        query = query.concat(
          `expenseNature.id${QueryOperator.Equal}${entity.expenseNature.id}${QueryOperator.Split}`
        );
      }
      if (entity.measurementUnit && entity.measurementUnit.id) {
        query = query.concat(
          `measurementUnit.id${QueryOperator.Equal}${entity.measurementUnit.id}${QueryOperator.Split}`
        );
      }
      if (entity.planningMetric && entity.planningMetric.id) {
        query = query.concat(
          `planningMetric.id${QueryOperator.Equal}${entity.planningMetric.id}${QueryOperator.Split}`
        );
      }
      if (entity.poiHead && entity.poiHead.id) {
        query = query.concat(
          `poiHead.id${QueryOperator.Equal}${entity.poiHead.id}${QueryOperator.Split}`
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/poi-body.service.ts